// Teto de ~25 MP (≈5000×5000, ~100 MB de bitmap RGBA). Já cobre folgadamente um A4 a 300+ DPI;
// acima disso uma imagem enorme (ex.: HEIC de celular) estouraria a memória da aba ao desenhar
// no canvas, então reduzimos a escala em vez de alocar o tamanho original.
const MAX_PIXELS = 25 * 1000 * 1000

export function convertImage (sourceFile, targetType, quality) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = function (event) {
      const img = new Image()

      img.onload = function () {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        const scale = Math.min(1, Math.sqrt(MAX_PIXELS / (img.width * img.height)))

        canvas.width = Math.max(1, Math.round(img.width * scale))
        canvas.height = Math.max(1, Math.round(img.height * scale))
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
        canvas.toBlob(function (blob) {
          // Libera o bitmap do canvas assim que o blob é gerado.
          canvas.width = canvas.height = 0

          // toBlob chama com null se o navegador não conseguir codificar — rejeita em vez de
          // montar um File a partir de null (que viraria um arquivo corrompido enviado em silêncio).
          if (!blob) {
            reject(new Error(`browser cannot encode ${sourceFile.type || sourceFile.name}`))

            return
          }

          const ext = targetType === 'image/jpeg' ? '.jpg' : '.png'
          const newFile = new File([blob], sourceFile.name.replace(/\.\w+$/, ext), { type: targetType })
          resolve(newFile)
        }, targetType, quality)
      }

      img.onerror = () => reject(new Error(`browser cannot decode ${sourceFile.type || sourceFile.name}`))

      img.src = event.target.result
    }
    reader.onerror = reject
    reader.readAsDataURL(sourceFile)
  })
}

export async function convertImagesInInput (input) {
  if (!input.files || input.files.length === 0) return

  const dt = new DataTransfer()
  let didConvert = false

  for (const file of Array.from(input.files)) {
    let converted = file

    try {
      if (['image/bmp', 'image/vnd.microsoft.icon', 'image/svg+xml', 'image/gif'].includes(file.type)) {
        converted = await convertImage(file, 'image/png')
        didConvert = true
      } else if (['image/heic', 'image/heif', 'image/heic-sequence', 'image/heif-sequence', 'image/avif', 'image/avif-sequence', 'image/webp'].includes(file.type)) {
        converted = await convertImage(file, 'image/jpeg', 0.9)
        didConvert = true
      }
    } catch (e) {
      window.Toast.error(e.message)
    }

    dt.items.add(converted)
  }

  if (didConvert) {
    input.files = dt.files
  }
}

export default class extends HTMLElement {
  connectedCallback () {
    const input = this.querySelector('input[type="file"]')
    const form = input.form

    input.addEventListener('change', async () => {
      await convertImagesInInput(input)

      form.querySelector('[type="submit"]')?.setAttribute('disabled', true)

      form.requestSubmit()
    })
  }
}
